import { render } from "./BodyDamage.vue?vue&type=template&id=9d814d7c&scoped=true&ts=true"
import script from "./BodyDamage.vue?vue&type=script&lang=ts"
export * from "./BodyDamage.vue?vue&type=script&lang=ts"

import "./BodyDamage.vue?vue&type=style&index=0&id=9d814d7c&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d814d7c"]])

export default __exports__